const route = {
	path: '/main',
	name: 'main',
	meta: {
		title: 'Principal',
	},
	component: () => import('@/pages/main/page-main'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/main.js